import createIcon from '../../createIcon';

/**
 * @component @name DomainVerification
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTYuNiAxMC44OEwxNS4xOCA5LjQ2TDEwLjk0IDEzLjcxTDguODIgMTEuNThMNy40IDEzTDEwLjk0IDE2LjU0TDE2LjYgMTAuODhaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTkgNEg1QzMuODkgNCAzIDQuOSAzIDZWMThDMyAxOS4xIDMuODkgMjAgNSAyMEgxOUMyMC4xIDIwIDIxIDE5LjEgMjEgMThWNkMyMSA0LjkgMjAuMTEgNCAxOSA0Wk0xOSAxOEg1VjhIMTlWMThaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const DomainVerification = createIcon('DomainVerification', [
  [
    'path',
    {
      d: 'M16.6 10.88L15.18 9.46L10.94 13.71L8.82 11.58L7.4 13L10.94 16.54L16.6 10.88Z',
      key: '1uojuw',
    },
  ],
  [
    'path',
    {
      d: 'M19 4H5C3.89 4 3 4.9 3 6V18C3 19.1 3.89 20 5 20H19C20.1 20 21 19.1 21 18V6C21 4.9 20.11 4 19 4ZM19 18H5V8H19V18Z',
      key: '1yqsft',
    },
  ],
]);

export default DomainVerification;
